import Tooltip from './tooltip.js';
import { stylesWebcomponent, stylesTooltip } from './styles.js';
import {baseUrl} from './base-url.js';

let retry = 0;

export class MonitorAppsComponent extends HTMLElement {
	services = [];
  _appKey = null;
  _env = null;
  connection = null;
  tooltip = null;
    
	
	constructor () {
		super();
		this.shadow = this.attachShadow({mode: 'open'});
	}

  // Getter
  static get observedAttributes() {
    return ['app-key', 'env'];
  }

  // Methods
  connectSignalR(){
    try{
      this.connection = new signalR
      .HubConnectionBuilder()
      .withUrl(`${baseUrl[this._env]}/sr-health-check/${this._appKey}`)
      .withAutomaticReconnect()
      .build();
    }catch(e){
      console.log('Intentando conectar a signalR...');
      retry ++;
      if(retry > 5) {
        console.log('No se pudo conectar a signalR');
        return;
      }
      setTimeout(() => this.connectSignalR(), 2000);
      return;
    }

    this.connection.start()
      .then(() => console.log('Conexión establecida'))
      .catch(err => console.error('Error al establecer la conexión: ', err));

    this.connection.on('state-changed', (serviceId, response) => {
      const index = this.services.findIndex(item => item.id === serviceId);
      if(index === -1) return;
      const {statusCode, errorMessage} = response;
      this.services[index].statusCode = statusCode;
      this.services[index].errorMessage = errorMessage;
      this.emit('state-changed', {serviceId, response, services: this.services});
      this.updateContent();
    });
  }

  emit(type, detail){
    let event = new CustomEvent(type, {
      bubbles: true,
      cancelable: true,
      composed: true,
      detail,
    });
    return this.dispatchEvent(event);
  }
  async getServices(){
    const response = await fetch(`${baseUrl[this._env]}/applications/${this._appKey}/services`);
    const data = await response.json();
    this.services = data.services.sort((a, b) => a.name.localeCompare(b.name));
  }
  async init(){
    this.render();
    this._appKey = this.getAttribute('app-key');
    this._env = this.getAttribute('env');
    try{
      if(!this._appKey || !baseUrl[this._env]) {
        throw new Error('No se han proporcionado las props requeridas');
      }
      await this.getServices();
      this.emit('services-loaded', this.services);
      this.updateContent();
      this.connectSignalR();
    }catch(e){
      console.error('Error al obtener los servicios: ', e);
      this.renderError();
    }
  }
	render() {
    this.shadow.innerHTML = `
      <div class="monitor-apps" part="monitor-apps">
        <h1 class="monitor-apps__title" part="monitor-apps__title">Estado de los servicios</h1>
        <div class="monitor-apps__content" part="monitor-apps__content">
          <div class="spinner" part="spinner"></div>
        </div>
      </div>
    `;
    const monitorAplicaciones = this.shadow.querySelector('.monitor-apps');
    this.tooltip = new Tooltip();
    monitorAplicaciones.addEventListener('mouseover', (event) => {
      const target = event.target.closest('.state-icon--ko');
      if (target) {
        const body = document.querySelector('body');
        body.appendChild(this.tooltip.tooltip);
        const text = target.getAttribute('data-tooltip');
        this.tooltip.show(text, target);
      }
    });
    
    monitorAplicaciones.addEventListener('mouseout', (event) => {
      const target = event.target.closest('.state-icon--ko');
      if (target) {
        this.tooltip.hide();
        const body = document.querySelector('body');
        body.removeChild(this.tooltip.tooltip);
      }
    });
  }
	updateContent() {
    const content = this.shadow.querySelector('.monitor-apps__content');
    content.innerHTML = `
      ${!this.services.length ? 
          `<div class="no-services" part="no-services">No hay servicios asociados a la aplicación</div>` :
          this.services.map(service => `
            <div class="service" part="service">
              <span 
                part="state-icon ${service.errorMessage ? 'state-icon--ko' : 'state-icon--ok'}"
                class="state-icon ${service.errorMessage ? 'state-icon--ko' : 'state-icon--ok'}" 
                data-tooltip="${`Error ${service.statusCode}:\n${service.errorMessage}`}"
              ></span>
              <span class="name" part="name">${service.name}</span>
            </div>
          `).join('')
      }
    `;
  }
	renderError() {
    const content = this.shadow.querySelector('.monitor-apps__content');
    content.innerHTML = `Ha ocurrido un error al conectar con el servidor. <br/>
    Revise el application key proporcionado y el entorno.`;
  }

  // Lifecycle hooks
  // OnInit
  connectedCallback () {
    // add signalR script
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/microsoft-signalr/8.0.7/signalr.min.js';
    document.head.appendChild(script);

    // add scoped styles
    const styleSheet = new CSSStyleSheet();
    styleSheet.replaceSync(stylesWebcomponent);
    this.shadow.adoptedStyleSheets = [styleSheet];

    // add global styles
    const styleElement = document.createElement('style');
    styleElement.textContent = stylesTooltip;
    styleElement.setAttribute('data-monitor-style-id', 'tooltip');
    document.head.appendChild(styleElement);

    this.init();
  }
  // OnDestroy
	disconnectedCallback () {
    const scripsSignalR = document.head.querySelector(`script[src="https://cdnjs.cloudflare.com/ajax/libs/microsoft-signalr/8.0.7/signalr.min.js"]`);
    document.head.removeChild(scripsSignalR);
    const tooltipStyle = document.head.querySelector(`style[data-monitor-style-id="tooltip"]`)
    document.head.removeChild(tooltipStyle);

    if(!this.connection) {
      return;
    }
    this.connection.stop().then(() => {
      this.connection = null;
      console.log('Conexión cerrada');
    });
	}
}
